module.exports = __webpack_public_path__ + "static/media/bg_plan_suggestion_from_40_to_44.7ad3d615.webp";